export default __webpack_public_path__ + "static/media/i_bus-dbl_rd.2ee4e044.svg";